const str = `{HEADER}利用規約

{BODY_TITLE}第一章　目的
本利用規約は、（株）ビデオモンスター（以下‘当社’といいます）が運営するビデオモンスターwebサイトとアプリケーションから提供される映像テンプレート関連デジタルコンテンツ（以下‘コンテンツ’といいます）サービスを利用するにあたって、当社のサービスの利用及び手続き又は当社と会員様の権利や義務事項，その他必要な諸般事項の手続きを目的としています。


{BODY_TITLE}第二章　利用規約の効力及び変更
１）本規約は、ビデオモンスターwebサイト及びアプリケーションに告知又は電子メールなどの方法で会員様に告知される事により効力が発揮されます。
２）関連法令に違反しない範囲内で、当社は前触れ無しに本規約を改正する事ができます。改正された規約は、第二章第一項目の方法を施行する事により効力が発揮されます。
３）規約を改正する際には、適用日及び改正事由明示しビデオモンスターに改正適用日7日前から告知させていただきます。ただし、会員様に不利な規約内容に変更する場合には最低３０日以上の事前猶予期間を持った後告知させていただきます。この場合当社は改正前の内容と改正後の内容を比較し利用者が分かりやすいよう表記させていただきます。
４）本規約に同意する事は、長期的にビデオモンスターを訪問し規約の変更事項を確認する事に同意する事を意味します。変更した規約に関する情報を知る事無く発生するユーザーの被害について当社は責任を負いません。
５）会員様は変更された規約に同意しなかった場合には会員退会（解約）をする事ができ、変更された規約の効力発生日以降にもサービスを継続して利用する場合規約の変更項目に同意されたものとみなされます。
６）本規約で定めていない事項と本規約の解約に関しては、電子上取引などの消費者保護に関する法律、公正取引委員会が指定した電子上取引などのサービス保護指針及び関係令又は商慣例に従います。


{BODY_TITLE}第三章　用語の定義
本規約で使用される用語は以下同様でございます。
１）‘会員’，‘利用者’，‘ユーザー’とは、サービスを提供してもらう為当社と利用契約を締結しユーザーIDを付与された人をいいます。
２）‘利用契約’とは、サービスを提供してもらう為当社と締結する契約を意味し‘会員登録’と通用する意味でもあります。
３）‘解約’とは、当社又は会員様の利用契約を解約する事をいい‘会員退会’と通用する意味でもあります。
４）‘サービス’とは、ビデオモンスターと通して提供されるコンテンツ及びコンテンツを制作する道具を意味します。
５）‘テンプレート’とは、当社がビデオモンスターを通して提供する情報伝達目的のあらかじめ制作された映像結果物で、複数の“映像，写真，アイコン，イメージ，図形，テキストなど”（以下‘デザイン要素’といいます）で構成されており、ビデオモンスター内から提供されるテンプレートを編集するソフトウェア（以下‘編集機’といいます）を通して編集が可能です。また、特別に‘利用者テンプレート’と称します。
６）‘レンダリング’とは、利用者が‘編集機’を通して‘利用者テンプレート’を作成する過程や、その結果を意味します。
７）‘ウォーターマーク’とは、当社が提供するコンテンツがむやみに使用される事を防ぎそのコンテンツの著作権者が誰であるかを知るために、当社やサービスのロゴなどをコンテンツの背景又は一部領域に表示する標識をいいます。


{BODY_TITLE}第四章　サービスの利用契約の成立
１）利用契約は、ビデオモンスター会員登録時に登録した利用申請について当社が承認する事により成立します。
２）本利用規約に関する同意は、利用申請時に同意ボタンをクリックすることにより規約に同意するものとみなします。
３）当社は必要に応じて実名確認及び本人認証を要請することができます。その手続きと方法に関しては関連令法に従います。


{BODY_TITLE}第五章　サービス利用申請
１）会員として加入し、本サービスを利用したい利用客は当社が要請する情報を提供しなければなりません。ただし、会員様が提供された情報はプライバシーポリシーに従い管理されます。
２）全ての会員様は必ず会員様本人の情報を提供しなければサービスを使用する事は出来ず、他人の情報を盗用し虚偽の情報を登録された場合には会員のサービス利用に関して、どのような権利も主張する事は出来ず関係法令に従い処罰される恐れがあります。
３）他人の情報を盗用し利用申請を行った会員様のIDは削除される恐れがあります。
４）会員登録は必ず本人の事実情報を通してのみ加入可能であり、当社は会員様が登録なされた情報に関して確認措置を行う事ができます。会員様は当社の確認措置に関し積極的に協力すべきであり、万一これを遵守しなかった場合当社は会員様が登録された情報を不正なものとして処理する事ができます。
５）当社は、サービスを利用される会員様に対して有料会員と無料会員に区分し有料会員においては利用対象によって等級を区分、各等級別にサービスの機能及びサービス適用範囲などに差をつける事ができます。


{BODY_TITLE}第六章　サービス利用の技術的要請項目
１）当社はサービスを供給しながら以下の<サービス利用必須仕様>が満たされれば正常的なサービス利用が可能であり、利用者が当該仕様に満たす事の出来ない事由でサービス利用に異議を申し立てる場合当社はその責任を負いません。
<サービス利用推奨仕様>
− オペレーティングシステム（OS）:コンピューター（PC），モバイル（Android OS,IOS）
− webブラウザー：クロムブラウザーを勧奨します（Internet Explorerを除くたいていのブラウザから利用可能であるが、一部機能が動作しない恐れがあります。）
− 動画・映像：M P４(M O Vの場合一部機能が動作しない恐れがあります。)


{BODY_TITLE}第七章　個人情報の保護及び利用
１）個人情報の保護及び利用に関して関連法令又は当社のプライバシーポリシーが適用されます。当社は関係法令に定めるところにより、会員様の個人情報を保護する為に努力します。ただし、会員様はパスワードなどが他人に露出されないよう注意し当社は会員様の帰責事由による露出した情報に対して責任を負いません。
２）当社は以下のような場合、法が許容される範囲内で会員様の個人情報を第三者に提供することができます。
①捜査機関やその他の政府機関からの情報提供を要求された場合
②会員様の法令及び規約の違反を含めた不正行為確認などの情報保護業務の為に必要な場合
③その他法律により要求される場合


{BODY_TITLE}第八章　利用制限
１）当社は以下の項目に該当する場合、会員様のサービス利用を制限又は利用承諾を撤回する事が出来ます。
①他人のeメールを盗用し加入した場合
②不正な用途で本サービスを利用する場合
③法令違反及び社会の安寧と秩序の約束を阻害する目的で利用した場合
④青少年保護法の趣旨に反する目的で本サービスを利用する場合
⑤その他規定した現行法令に反する目的で本サービスを利用する場合
⑥本サービスと競争関係にあるユーザーが当社の利益を阻害する目的で利用する場合
⑦その他規定した諸般の事項に違反して申請した場合
２）当社は会員様のサービス利用中次の各項目に該当する場合には、その利用に対して以下の事由が解消されるまで利用を制限する事が出来ます。
①当社が設備の余裕が無い場合
②当社の技術上支障がある場合
③その他当社の帰責事由で利用が困難な場合
ただし、有料会員の場合第十三章（決済キャンセル及び払戻）の規定に従います。


{BODY_TITLE}第九章　利用者ID付与及び変更など
１）当社は利用されるお客様に対して規約が定めるところにより、利用者IDを付与します。
２）利用者IDは原則的に変更が不可能であり、やむを得ない事由に関して変更する場合には該当するIDを解約した後再加入をしなければいけません。
３）利用者IDは以下の項目に該当する場合、会員様の要求及び当社の職権に変更又は利用を停止する事ができます。
①利用者IDが個人を識別する事のできる情報でプライバシーの侵害に憂慮される場合
②他人に嫌悪感を与るなど、美風良俗に反する場合
③当社や当社のサービス又はサービス運営者などの名称と同じ場合や誤認などの恐れがある場合
④その他合理的な事由がある場合
５）利用者ID及びパスワードの管理責任は利用者にあります。管理を疎かにし発生するサービス利用上の損害、又は第三者による不正利用などに対する責任は利用者本人にあり、当社は一切責任を負いません。
６）その他の利用者の個人情報管理及び変更に関する事項は、サービス内のプライバシーポリシーに従います。


{BODY_TITLE}第十章　当社の義務
１）当社は利用されるお客様が望まれるサービス提供開始日に、特別な事情が無い場合サービスを利用する事の出来るよう提供します。
２）当社は継続的で安定的なサービス提供の為に設備に障害が発生する場合は、やむを得ない事由が有る限り遅滞なくこれを修理又は復旧しなければなりません。
３）当社は個人情報保護の為にプライバシーポリシーを公示し遵守しなければいけません。
４）当社は利用されるお客様から提起される意見や不満が正当だと判断される場合には、適切な手順を踏み反映及び改善しなければなりません。ただし、直ちに処理が困難な場合には利用者にその理由と処理日程を通知しなければなりません。


{BODY_TITLE}第十一章　会員の義務
１）会員様は会員登録申請及び会員情報変更時、全ての項目に事実に基づいて作成しなければなりません。虚偽又は他人の情報を利用した事実が発覚した場合、サービス利用及び関連する全ての権利を主張する事が出来ません。
２）会員様は本規約が規定する事項及びその他当社が定めた諸般の規定、当社が公示する事項又は関係法令に遵守しなければいけません。また、会員様は当社の業務を妨害する行為や当社の名誉を損傷する行為、他人に被害を与える行為をしてはいけません。
３）会員様は青少年保護法などの関係法令を遵守しなければいけません。会員様が青少年保護法などの関係法令に反する場合、該当する法令に従い処罰を受ける事になります。
４）会員様は付与されたID及びパスワードを直接管理しなくてはいけません。会員様が管理を疎かにし発生する損害に関する責任は会員様個人にあります。
５）会員様は当社の事前承諾無しにサービスを利用し営業活動を行う事は出来ず、その営業活動による結果に対する責任は会員様個人にあります。また、会員様は以下のような営業活動により当社に損害を与えた場合会員様は当社に対する損害賠償の義務を負う事になり、当社はその会員様に関してのサービス利用及び制限又は適法な手続きを経た後損害賠償などを請求する事ができます。
６）会員様は当社の明示の同意が無い限り、サービスの利用権限やその他利用契約上の地位を他人に譲渡又は贈与する事は出来ず、これを担保にする事は出来ません。
７）会員様は当社及び第三者の知的財産権を侵害してはなりません。
８）会員様は以下各項目に該当する行為をしてはいけません。該当する行為をされた場合、当社は会員様のサービス利用制限及び適切な措置を含む制裁を加える事が出来ます。
①会員登録申請及び会員情報変更時、虚偽の内容を登録する行為
②他のユーザーのeメールやID、パスワードなどの盗用行為
③当社の運営スタッフまたは関係者を詐称する行為
④当社からの特別な権利を受けず、当社のサーバーをハッキング及び掲示された情報の一部または全てを任意に変更するなど当社のサービスを異常な方法で使用する行為
⑤当社のプログラム上のバグを悪用する行為
⑥正常ではない方法で有料会員の権利を獲得する行為
⑦サービスに危害を加えるなど、故意にサービスを妨害する行為
⑧当社の事前承諾無しにサービスを利用し営業活動を行う行為
⑨他人の特権，商標，営業秘密，著作権，その他の知的財産権を侵害する内容を送信、掲示及びビデオモンスターを通し他人に流出する行為
⑩青少年保護法及び刑法に違反する低俗、淫らな内容の情報又は文章，図形，音響，動画や映像などを伝送，掲示するにあたってビデオモンスターを通し他人に流出する行為
11．屈辱的であるなど個人の身の上に関する内容、他人の名誉やプライバシーを侵害する恐れのある内容を転送又は掲示する事など、ビデオモンスターを通して他人に流出する行為
12．その他のユーザーをセクハラ、脅威または特定の利用者に持続的に苦痛及び不便を与える行為
13．当社の承認を得ず他の利用者の個人情報を収集または保存する行為
14．犯罪に関連すると客観的に判断される行為
15．本規約を含め、他社がビデオモンスターに公示した内容及び規定を違反する行為
16．その他関係法令に違反する行為


{BODY_TITLE}第十二章　有料サービス
１）ビデオモンスターの会員加入およびサービスは一定期間、無料で利用できます。ただし、無料利用者についてはテンプレート及び‘利用者テンプレート’にウォーターマークが挿入されたり、‘利用者テンプレート’の使用に制限があったりするなどサービスの一部分機能に制限がかかる場合があります。有料サービス利用者については、使用目的及び対象などにより差等がある場合があります。有料又は無料サービス利用に関する事項は当社がビデオモンスターに公開した別途の価格方針及びライセンス規定に従います。
２）有料サービスは、ウォーターマーク除去のような一回性サービスと一定期間に該当する料金を前払いし当該期間中にサービスを利用する‘期間満了型料金プラン’や会員様が登録した決済手段を通じ月単位で利用料金が自動的に決済され利用期間が自動更新される‘定期決済型料金プラン’を意味します。
３）有料サービス中の期間満了型料金プランは、６ヶ月/１年の加入期間に区分し加入が可能であり加入期間によって割引価格が適用され、価格はビデオモンスター内で公示されます。
４）有料サービスは‘公共機関’/‘教育機関’と共に、利用対象又は提供機能によって差別価格の料金プランを設ける事ができ、‘料金制のアップグレード’を通し上位料金プランに移動できます。
５）有料サービスの価格及びポリシーは当社が事前に公示しなくとも変更可能であり、すでに利用中の有料加入者の該当する登録期間中には変更された価格及びポリシーが適用されません。
６）有料サービスの決済は当社が指定した決済手段の中で、会員様の望む決済手段を選択し決済する事ができます。
７）有料利用者は他人に有料サービスの利用権利を譲渡/販売/レンタルは出来ません。
８）当社はテンプレート以外のその他コンテンツや付加サービス（デザイン要素）など、他社との提携サービスなどを提供する事が出来ます。


{BODY_TITLE}第十三章　有料サービス変更
１）会員様がすでに購入された有料サービスは原則的に変更処理されず解約後に他の利用プランとして登録する事になっていますが、当社が事前に公示した後指定する一部の利用プランに関して会員様が変更又は申請された場合には、１ヶ月後に変更予約及び即時変更処理が可能です。
２）変更予約をされる場合、会員様が変更申請を行った月の利用期間が満了する日まで既存購入された利用プランを利用する事ができ、利用期間満了日の翌日から変更申請された利用プランに変更されます。
３）即時変更の場合、会員様が即時変更申請をなさってから当社が受付完了後即時に既存購入された利用プランの利用を中断し、申請されたプランに変更されます。


{BODY_TITLE}第十四章　決済キャンセル及び払戻
１）会員様がすでに購入された有料サービスについてはデジタルコンテンツの特性上原則的に決済キャンセルが不可能でございます。そのため、決済時には必ず慎重に判断し決済を行ってください。ただし、以下の場合については払戻及びサービス期間の無料延長措置を取らせていただきます。
①有料サービスを消費者が購入したが全く使用しなかった場合（映像を制作しなかった場合）については、決済された日から１５日以内に決済キャンセル（契約解除）を申請する事ができます。
②有料サービスを購入したが、２４時間前の事前告知なしに３日以上サービスが中断又は障害が発生した場合や１ヶ月の間にサービス中断・障害発生累積時間が７２時間を超過した場合、当社に帰責事由がある場合に会員様は払い戻し要請をされるか中断された期間分を無料で延長要請する事ができます。
③有料サービスを購入したが、サービス点検などの事由によりサービス中断・障害発生する恐れがある事を事前に告知したにも関わらずサービス中断・障害発生時間が１０時間を超えた場合は超過した時間の分、利用期間を無料で延長させていただきます。
④その他消費者保護の為、当社で別途定める場合としサービス中断・障害時間に争いがある場合、消費者は当社に通知した後から計算するとしサービスが不可抗力（天災地変など）で消費者の過失による中断や障害が発生した場合には、サービス中断・障害時間計算からは除外されます。
２）上１項の契約の申し込み撤回が可能な有料サービス又は利用権に対し決済取消可能期間（決済された日から１５日以内）を経過し契約の申し込みの撤回を申請、電子商取引等における消費者の保護に関する法律やコンテンツ産業振興法又はコンテンツ利用者保護指針などその他関係法令が定めた契約の申し込み撤回制限の事由に該当する場合には、決済キャンセルが制限されます。
３）支払われた口座は、決済者の氏名と預金者の氏名が同一の本人口座でなければなりません。
４）イベント又は無料クーポンなど、無料で購入された場合払い戻し対象から除外されます。


{BODY_TITLE}第十五章　払い戻し手続き
１）本規約第十四章（ 決済キャンセル及び払戻）に基づく払い戻しについての申請はビデオモンスター決済内訳を通し会員様が直接行う事が出来ます。
２）会員の払い戻し意思表示に対し当社が返信した日から営業日基準３日以内に払い戻し処理を行い、払い戻しが不可能な場合には該当する内容を事前に告知します。ただし、収納の確認が必要な決済手段は収納確認日から営業日３日以内に払い戻しさせていただきます。


{BODY_TITLE}第十六章　過誤金の払い戻し
１）当社は有料サービス決済と関連した過誤金が発生する場合、利用代金の決済方法と同様の方法で過誤金全金を払い戻しさせていただきます。ただし、同様の方法で払い戻しが不可能な場合には事前に告知します。
２）当社の帰責事由により過誤金が発生した場合、当社が過誤金を払い戻しするにあたって所有される費用は合理的な範囲内で利用者が負担しなければならず、当社は該当する費用を差引後に過誤金を払い戻しする事ができます。
３）当社は会員様が要求する過誤金に対して払い戻しを拒否する場合、有料サービス料金が正しく賦課された事を立証する責任を負います。


{BODY_TITLE}第十七章　サービス利用時間
１）サービス利用は当社の業務上又は技術上特別な支障がない限り年中無休、１日２４時間運営を原則的にしています。ただし、システム定期点検や増設及び取り替えの為に会社が定めた日/時間にサービスを一時中断する事ができ、予定された作業によるサービスの一時的な中断はビデオモンスターを通して事前に公示させていただきます。
２）当社は緊急システム点検、増設及び取り替えなどやむを得ない事由により予告無く一時的にサービスを中断する事ができ、新しいサービスへの変更など当社が適切だと判断した理由により現在提供させていただいているサービスを完全に中断する事ができます。
３）当社は国家非常事態や停電、サービス設備の障害又はサービス利用によるラッシュなど正常的なサービス提供が不可能な場合、サービスの全て又は一部を制限及び提供する事が出来ます。ただし、この場合その理由及び期間などを会員様に事前又は事後に告知します。


{BODY_TITLE}第十八章　会員番号管理
１）利用者のIDとパスワードに関する全ての管理責任は会員様にあります。
２）当社は利用者IDを利用者が加入時記録したeメールを使用し、これを利用者の唯一の区別者として諸般のユーザー管理業務を遂行する為、会員様は利用者IDを変更する事は出来ません。変更されたい場合には、解約後に他のIDで新しく加入しなくてはいけません。
３）ユーザーが登録した利用者ID及びパスワードにより発生する利用者の過失、又は第三者による不正使用などに関する全ての責任は該当するユーザーにあります。


{BODY_TITLE}第十九章　テンプレートの管理
１）当社は以下の項目に該当する‘利用者テンプレート’やコンテンツ、掲示物や資料を事前告知無しに削除又は移動、登録を拒否する事が出来ます。
①他の会員様又は第三者にひどい侮辱を与えるなど中傷謀略の為に名誉を傷つける内容の場合
②青少年保護法に違反する内容の情報，文章，図形などを掲示又はリンクさせる場合
③青少年保護法に違反するわいせつな内容や、わいせつサイトをリンクさせる場合
④不法コピー又はハッキングを助長する内容の場合
⑤犯罪と結びついていると客観的に認められる内容の場合
⑥他の利用者又は第三者の著作権などその他の権利を侵害する内容の場合
⑦その他関係法令に違反すると判断される場合
2) 当社は「ユーザーテンプレート」を一定期間保管し、一定期間が経過した後、円滑な運営のために削除および初期化されす。 削除および初期化された「ユーザーテンプレート」は復元できません。
① 完成した動画の場合、動画内にユーザーが直接入れた画像、映像のみ削除(ダウンロードおよび映像視聴のみ可能)
② 未完成の動画の場合、ユーザーが直接入れた画像、映像を含めて動画データを完全に削除
会員別の保管期間は、[マイ動画] → [保管期間]でご確認いただけます。



{BODY_TITLE}第二十章　著作権
１）ビデオモンスターから提供する全てのテンプレート又は‘映像のデザイン要素’の著作権は当社にあります。したがって、利用者はテンプレート及び‘映像のデザイン要素’などを再販売する事は出来ず利用者は使用権を有します。著作権に関してビデオモンスターに掲示したライセンス規定が適用されます。
２）会員様がビデオモンスターに登録したイメージなどが、他人の著作権違反がある場合これに対する全ての法的責任は当社にあらず登録された会員様にあります。
３）当社は会員様が制作した‘利用者テンプレート’などの掲示物に対し第十九章（テンプレートの管理）各項目に該当すると判断される場合、事前告知無しに削除や移動及び登録を拒否する事が出来ます。
４）当社は必要に応じて会員様が制作された‘利用者テンプレート’の内ギャラリーにアップロードしたコンテンツをマーケティング素材に使用する事が出来ます。


{BODY_TITLE}第二十一章　情報の提供
１）当社は会員様にサービスを利用するにあたって必要があるとみなされる各種情報に対し、サービス内の画面や電子メール又は信書便などの方法で会員様に提供する事が出来ます。
２）当社はサービス追加、改善及び会員対象のサービス紹介などの目的で会員様の同意のもとに追加的な個人情報を要求する事が出来ます。


{BODY_TITLE}第二十二章　広告掲載及び広告主との取引
１）当社のサービスを利用される会員様はサービス利用時、露出する広告の掲載に同意したものとみなされます。
２）当社は本サービスに掲載されているか、本サービスを通じた広告主の販促活動に会員が参加及び交信、又は取引の結果として発生する全ての損失や損害に対して責任を負いません。


{BODY_TITLE}第二十三章　サービス利用制限
１）当社は会員様がサービス利用内容において本規約第十一章の内容を違反するなど以下項目に該当する場合、事前告知無しにサービスの利用を制限する事が出来ます。
①美風良俗を阻害する卑俗なID及びニックネームの使用
②他の会員様のID及びパスワードを盗用した場合
③他人の情報を盗用し会員登録を行った場合
④他のユーザーにひどい侮辱を与えるなど、サービスの利用を阻害した場合
⑤サービスに危害を加えるなど故意に妨害した場合
⑥その他正常的なサービス運営に妨害する場合
⑦青少年保護法など関係法令に禁止されている情報を転送又は掲示した場合
⑧放送通信委員会など関連公共機関の是正要求がある場合
⑨本規約を含む他社が定めた諸般の規定又は利用条件を違反した場合
⑩その他関係法令に違反する場合
２）サービス利用制限は一時停止，永久停止，利用契約解約などに区分されます。
３）当社はサービス利用制裁を受けたユーザーに、制裁内容についてeメールで内容を伝達し７日以内に釈明の機会を提供した後異議申し立てに対する適切な事由があれば、制裁された内容は解除出来ます。
①有料ユーザーが当社の定めた期間内の釈明の機会を通し、自身の故意や過失がなかった事を立証した場合、当社はサービスが制限された期限について期限延長を提供させていただきます。


{BODY_TITLE}第二十四章　契約変更及び解約
１）会員様が利用契約を解約されたい場合には会員様ご本人がサービス内のメニューを通して加入解約をしなければならず、ウェブ内のメニュー利用が不可能な状況につきましては相談窓口を通し契約解約が可能でございます。
①相談窓口の連絡先及びeメールはビデオモンスターサービス内に明示されています。
２）有料会員の場合解約の際、有料使用期間が残ったとしても第十四章１）の①項目に該当する場合ではない限り払い戻しされません。


{BODY_TITLE}第二十五章　紛争解決
１）当社は会員様が申し立てる正当な意見や不満を反映し、その被害を補償処理する為、必要に応じて被害補償処理会議を招集・運営します。
２）当社は会員様から出される苦情や意見を優先して処理します。ただし、迅速な処理が困難な場合は利用者にその理由と処理日程を通知させていただきます。
３）当社と会員様の間に発生する電子商取引紛争と関連し、ユーザーの被害救済の申請がある場合には公正取引委員会又は市・都市が依頼する紛争調整機関の調整に従う事があります。


{BODY_TITLE}第二十六章　免責条項
１）当社は天災地変，戦争及びその他の事に準する不可抗力により、サービスを提供出来ない場合にはサービス提要に対する責任が免除されます。
２）当社は基幹通信産業者が電気通信サービスを中止、又は正常に提供しなかったために損害が発生した場合その責任が免除されます。
３）当社はサービス用設備の補修，交換，定期点検，工事などのやむを得ない理由により発生した損害に関する責任が免除されます。
４）当社は会員様の帰責によるサービス利用の障害又は損害についての責任を負いません。
５）当社は利用者の器械による損害が発生した場合、又は会員様が個人情報及び電子メールアドレスを不実に記載し損害が発生した場合責任を負いません。
６）当社は会員様がサービスを利用なさりながら得られた資料による損害に関して責任を負いません。又、当社は会員様がサービスを利用されながら他の会員様により受けた精神的・物質的被害に対して、補償の責任を負いません。
７）当社はビデオモンスター内に登録されたテンプレートなどの各種コンテンツ，掲示物，登録資料に関する事実の信頼度，正確性などの内容及びその意味に対する責任を負いません。
８）当社は会員が登録したテンプレートなどの各種コンテンツ，掲示物，登録資料等が他人の著作権を侵害する場合、会員様に責任があるものとみられ当社は責任を負いません。
９）当社はユーザー相互間及びユーザーと第三者相互間において、サービスを媒介にした紛争に介入する義務が無く、それに対する損害を賠償する責任もありません。
10）ビデオモンスターのウェブサイト及びアプリケーションはハードウェア又はソフトウェア的なエラーが発生する可能性があります。当社は最善を尽くしエラーの発生を防ぐ為努力させていただきますが、エラー発生による作業物の流失の被害について当社は責任を負いません。
11）ビデオモンスターのサービス障害又は通信障害、ビデオモンスターを使用出来なくなったために発生するユーザーのデーターの流失，物質的/精神的損失，ビジネスの中断などによる被害に関し当社は責任を負いません。
12）ビデオモンスターは事前通知無しにコンテンツ，ソフトウェア，掲示物などを変更出来ます。


{BODY_TITLE}第二十七章　裁判権及び準拠法
１）規約に明示されていない項目が関係法令に規定されている場合は該当する規定に従います。
２）当社の有料サービス利用ユーザーの場合、当社が別途に定めた規約やポリシーがある場合それに従います。
３）サービス利用により発生した紛争に関する訴訟が起こされる場合、当社の所在地を管轄する裁判所を管轄裁判所とします。
４）当社とユーザー間に提起された電子商取引訴訟には、大韓民国の方が適用されます。

{FOOTER}<付則>
{FOOTER_SUB}本政策は２０２4年11月１８日から施行します。
`

export default str